import {
  aCreateSuppressList,
  aSuppressList,
  mockCreateSuppressedListOperationMutation,
} from '__generated__';

export const handlers = [
  mockCreateSuppressedListOperationMutation((req, res, ctx) => {
    const { defaultTtl, description, name, targetColumn } =
      req.variables.fields;

    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Mutation',
        createSuppressList: aCreateSuppressList({
          data: aSuppressList({
            id: '0',
            defaultTtl,
            description,
            name,
            targetColumn,
          }),
        }),
      })
    );
  }),
];
